import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowRoundForward } from "react-icons/io";
import { Backdrop, CircularProgress } from "@mui/material";
import sproxillogo from "../../images/headerimges/mis-survey/sproxillogo.png";
import clockIcon from "../../images/headerimges/mis-survey/clock.svg";
import securedIcon from "../../images/headerimges/mis-survey/security.svg";
import rewardIcon from "../../images/headerimges/mis-survey/money.svg";
import nmepImage from "../../images/headerimges/mis-survey/nmep.svg";
import gatesfoundationImage from "../../images/headerimges/mis-survey/gatesfoundation.jpeg";
import { useValidateSurveyCode } from "api/hooks";
import toast from "react-hot-toast";
import { resetState, setRespondent } from "store/features/misSurveySlice";
import { useDispatch } from "react-redux";
import { secureStorage } from "utils/encryptionUtil";
import { difference } from "lodash"

let nextSectionId = null;

const MISLongSurvey = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const urlSurveyCode = queryParams.get("c") ?? "";

	const { validateCode, isLoading, isError } = useValidateSurveyCode({
		onSuccess: (data) => {
			toast.success("You have access to this survey");
			secureStorage.setSession("::dc::us-mls::resp", data?.data);
			const sectionHistoryArray = (difference(data?.data?.sections ?? [], data?.data?.section_history ?? [])).sort((a, b) => a - b)
			if (sectionHistoryArray?.length <= 0) {
				console.log({ sectionHistoryArray });
				navigate("/ml-thank-you", { replace: true });

				return;
			}

			//save the section history to local storage
			secureStorage.setLocal("sectionHistoryData", sectionHistoryArray);
			dispatch(setRespondent(data?.data?.respondent));
			//get next section id
			nextSectionId = sectionHistoryArray[0];
			if (
				secureStorage.getSession("::dc::us-mls::resp").respondent
					.gender === "Male" &&
				(nextSectionId === 5)
			) {
				let newMaleSections = sectionHistoryArray.filter(
					(id) => id !== 5
				);
				secureStorage.setLocal("sectionHistoryData", newMaleSections);

				navigate(`/ml-participant/`, {
					replace: true,
				});
			} else {
				navigate(`/ml-participant/`, {
					replace: true,
				});
				secureStorage.setLocal(
					"sectionHistoryData",
					sectionHistoryArray
				);
			}
		},
		onError: (error) => {
			const errorMessage = error?.response?.data?.message;
			toast.error(
				errorMessage || "You do not have access to this survey"
			);
		},
	});

	const proceedToSurvey = () => {
		validateCode({ survey_code: urlSurveyCode ?? "", survey_id: 1 });
	};

	useEffect(() => {
		const agentNumber = queryParams.get("userId") ?? "";
		const surveyChannel = queryParams.get("channel") ?? "";
		const shouldReset = queryParams.get("reset");
		if (urlSurveyCode) {
			secureStorage.setSession("::dc::us-mls", urlSurveyCode);
			secureStorage.setSession("::agent::us-mls", agentNumber);
			secureStorage.setSession("::channel::us-mls", surveyChannel);
		}

		if (shouldReset) {
			sessionStorage.removeItem("persist:smis::heartbeat");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, navigate]);

	useEffect(() => {
		const shouldReset = queryParams.get("reset");
		console.log({ shouldReset });
		if (shouldReset) {
			dispatch(resetState());
		}
	}, []);

	const showLoadingBackdrop = isLoading;
	return (
		<section className={styles.container}>
			<Backdrop
				sx={(theme) => ({
					color: "#fff",
					zIndex: theme.zIndex.drawer + 3,
				})}
				open={!isError && showLoadingBackdrop}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
			<div className={styles.image_wrapper}>
				<img src={sproxillogo} alt="sproxil" />
			</div>

			<div className={styles.introduction_wrapper}>
				<h2>Help Shape Nigeria's Fight Against Malaria</h2>
				<p>
					Share your experience with malaria to strengthen prevention
					and treatment in your community. Your insights will directly
					impact healthcare initiatives across Nigeria.
				</p>

				<section className={styles.introduction_icons}>
					<div className={styles.survey_icon_summary}>
						<img src={clockIcon} alt="fast survey" />
						<p>
							Quick <span>20-minute</span> survey
						</p>
					</div>
					<div className={styles.survey_icon_summary}>
						<img src={securedIcon} alt="fast survey" />
						<p>
							100% <span>confidential responses</span>
						</p>
					</div>
					<div className={styles.survey_icon_summary}>
						<img src={rewardIcon} alt="fast survey" />
						{/* <p>
							Get back <span> airtime</span>{" "}
							instantly
						</p> */}
					</div>
				</section>

				<section className={styles.consent}>
					<p>
						Starting survey indicates that you agree to the{" "}
						<Link to={"https://sproxil.com/terms-of-service/"}>
							Terms & Conditions
						</Link>
					</p>

					<button
						type="button"
						disabled={isLoading || !urlSurveyCode}
						onClick={proceedToSurvey}
						data-testid="start_survey_button"
					>
						Start Survey{" "}
						<IoIosArrowRoundForward color="white" size={24} />
					</button>
					<p>Together, we can defeat malaria in Nigeria</p>
				</section>

				<section
					className={styles.sponsors}
					data-testid="start_survey_button"
				>
					<img src={nmepImage} alt="nmep" />
					<img src={gatesfoundationImage} alt="gates foundation" />
				</section>
			</div>
		</section>
	);
};

export default MISLongSurvey;
